const model = {
    accommodationCount: {},
    loading: false,
    errors: null,
};

export default model;
